import { URL } from "../constants";
import { apiSlice } from "./apiSlice";

export const productApi = apiSlice.injectEndpoints({
  tagTypes: ["Product"],
  endpoints: (builder) => ({
    getProducts: builder.query({
      query: (params) => ({
        url: `${URL}/products`,
        method: "GET",
        params: {
          page: params?.page,
          keyword: params?.keyword,
          category: params?.category,
          sup_category: params?.sup_category,
          select: params?.select,
          fields: params?.fields,
          sort: params?.sort,
          product_Attributes: params?.product_Attributes,
        },
      }),
      providesTags: ["Product"],
    }),

    getProductDetails: builder.query({
      query: (id) => `${URL}/products/${id}`,
    }),


    getAttributesValues: builder.query({
      query: (name) => ({
        url: `${URL}/products/attributes/values`,
        method: "GET",
        params: {
          categoryName: name,
        },
      }),
    }),
  }),
});

export const {
  useGetProductsQuery,
  useGetProductDetailsQuery,
  useGetAttributesValuesQuery,
} = productApi;
